import type { PageAndEmptyParams } from '@aurora/shared-client/routes/endUserRoutes';
import useEndUserRoutes from '@aurora/shared-client/routes/useEndUserRoutes';
import { EndUserPages } from '@aurora/shared-types/pages/enums';
import React from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import BrandLogo from '../BrandLogo/BrandLogo';

interface Props {
  /**
   * Set a custom element for this component.
   */
  as?: React.ElementType;
  /**
   * Class name(s) to apply to the component element.
   */
  className?: string;
}

/**
 * Displays brand logo as a link to the home page.
 *
 * @constructor
 *
 * @author Adam Ayres
 */
const BrandLogoWithLink: React.FC<React.PropsWithChildren<Props>> = ({ as = 'a', className }) => {
  const Component = as;
  const { Link, loading: loadingRoutes } = useEndUserRoutes();
  const cx = useClassNameMapper();

  if (loadingRoutes) {
    return null;
  }

  return (
    <Link<PageAndEmptyParams> route={EndUserPages.CommunityPage} passHref legacyBehavior={true}>
      <Component className={cx(className)}>
        <BrandLogo className={className} />
      </Component>
    </Link>
  );
};

export default BrandLogoWithLink;
